import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'lock-icon',
  templateUrl: './lock-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class LockIconComponent {}
